<script lang="ts">
  export interface CardContentSplitProps {
    title: string
    description?: string
  }
</script>

<script setup lang="ts">
  const props = defineProps<CardContentSplitProps>()
</script>
<template>
  <div class="flex gap-6 p-6">
    <div class="w-md flex flex-col gap-2">
      <div class="text-base font-medium">{{ props.title }}</div>
      <div v-if="props.description" class="font-regular text-soft">
        {{ props.description }}
      </div>
    </div>
    <div class="flex grow flex-col gap-6">
      <slot />
    </div>
  </div>
</template>
